import ImportData from './ImportData';

export default ImportData;
